import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7966c3ec")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Aguarde mientras se cargan las comisiones ")
const _hoisted_3 = { class: "p-d-flex p-ai-center p-jc-around p-p-2" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "País", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Cursos", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold p-mr-3" }, "Comienza en", -1)
const _hoisted_8 = { class: "pi pi-info-circle text-size-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold p-mr-3" }, "Termina en", -1)
const _hoisted_10 = { class: "pi pi-info-circle text-size-12" }
const _hoisted_11 = {
  key: 0,
  class: "p-d-flex p-flex-column p-flex-wrap"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Días y horarios", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "p-p-0 p-mb-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-p-0" }, " Profesor ", -1)
const _hoisted_16 = { class: "p-col-5 p-p-0" }
const _hoisted_17 = {
  key: 1,
  class: "p-d-flex p-ai-baseline p-col-12 p-p-0 p-mb-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-p-0" }, " Profesor ", -1)
const _hoisted_19 = { class: "p-col-4 p-p-0" }
const _hoisted_20 = { class: "p-d-flex p-ai-baseline p-col-12 p-p-0 p-mt-1" }
const _hoisted_21 = { class: "p-col-6 p-d-flex p-p-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-p-0 p-mr-2" }, " Tutores ", -1)
const _hoisted_23 = { class: "p-col-4 p-p-0" }
const _hoisted_24 = { class: "p-col-6 p-d-flex p-p-0" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-p-0 p-mr-4" }, " Coordinador ", -1)
const _hoisted_26 = { class: "p-col-4 p-p-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Staff", -1)
const _hoisted_28 = { class: "p-d-flex" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Estados", -1)
const _hoisted_30 = { class: "p-d-flex p-flex-column p-mt-2" }
const _hoisted_31 = { class: "p-col-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "SoldOut", -1)
const _hoisted_33 = { class: "p-col-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Cancelada", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_CoursePlanSelector = _resolveComponent("CoursePlanSelector")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DaysOfWeekSelector = _resolveComponent("DaysOfWeekSelector")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_CoderBadge = _resolveComponent("CoderBadge")!
  const _component_TrueOrFalseSelector = _resolveComponent("TrueOrFalseSelector")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "active-courses-table p-datatable-ssm",
    paginator: true,
    rows: _ctx.recordsPerPage,
    value: _ctx.courses,
    dataKey: "id",
    responsiveLayout: "scroll",
    loading: !_ctx.courses,
    filterDisplay: "menu",
    filters: _ctx.filters,
    "onUpdate:filters": [
      _cache[13] || (_cache[13] = ($event: any) => (_ctx.filters = $event)),
      _ctx.updateFilters
    ],
    totalRecords: _ctx.totalRecords,
    lazy: true,
    first: _ctx.firstRecord
  }, {
    empty: _withCtx(() => [
      _hoisted_1
    ]),
    loading: _withCtx(() => [
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.Id,
        header: _ctx.allColumns.get(_ctx.ColumnFields.Id)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.Id),
        columnKey: "id",
        showFilterMatchModes: false,
        filterField: "countries",
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: {
            name: _ctx.EducationRouteNames.COURSE_DETAIL,
            params: {
              courseId: data._id
            }
          }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.id), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("img", {
              src: _ctx.Country.getIconUrlFromCountryCode(data.country?.code),
              alt: data.country?.code
            }, null, 8, _hoisted_4)
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _hoisted_5,
          _createVNode(_component_CountrySelector, {
            class: "p-mt-3",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            disabled: _ctx.loading
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-text button-underlined"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.Name,
        header: _ctx.allColumns.get(_ctx.ColumnFields.Name)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.Name),
        showFilterMatchModes: false,
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CourseName }),
        filterField: "coursePlans",
        bodyClass: "bg-gray"
      }, {
        filter: _withCtx(() => [
          _hoisted_6,
          _createVNode(_component_CoursePlanSelector, {
            class: "p-mt-3",
            modelValue: _ctx.filters.coursePlans.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters.coursePlans.value = $event)),
            disabled: _ctx.isLoading,
            coursePlans: _ctx.allCoursePlans,
            multipleSelection: true,
            filter: true
          }, null, 8, ["modelValue", "disabled", "coursePlans"])
        ]),
        filterclear: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-text button-underlined",
            label: "Limpiar",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cleanFilters([_ctx.CourseFiltersProps.courseType, _ctx.CourseFiltersProps.coursePlans])))
          })
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.Start,
        header: _ctx.allColumns.get(_ctx.ColumnFields.Start)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.Start),
        showFilterMatchModes: false,
        filterField: "startMonth",
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data: { calendar }}) => [
          _createElementVNode("span", null, _toDisplayString(calendar.formatDate('start', _ctx.FormatDates.LatinAmerica)), 1)
        ]),
        filter: _withCtx(() => [
          _hoisted_7,
          _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
            [
              _directive_tooltip,
              'Al ser comisiones que no comenzaron, solo podrás elegir de este mes en adelante',
              void 0,
              {
                top: true,
                blur: true
              }
            ]
          ]),
          _createVNode(_component_Calendar, {
            modelValue: _ctx.filters.startMonth.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters.startMonth.value = $event)),
            class: "p-mt-3",
            view: "month",
            dateFormat: "MM yy",
            showIcon: true,
            minDate: new Date(),
            yearRange: "2020:2024",
            placeholder: "Seleccionar",
            showButtonBar: true
          }, null, 8, ["modelValue", "minDate"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-text button-underlined"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.End,
        header: _ctx.allColumns.get(_ctx.ColumnFields.End)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.End),
        bodyClass: "bg-gray",
        showFilterMatchModes: false,
        filterField: "endMonth"
      }, {
        body: _withCtx(({ data: { calendar } }) => [
          _createTextVNode(_toDisplayString(calendar.formatDate('end', _ctx.FormatDates.LatinAmerica)), 1)
        ]),
        filter: _withCtx(() => [
          _hoisted_9,
          _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
            [
              _directive_tooltip,
              'Al ser comisiones que no comenzaron, solo podrás elegir de este mes en adelante',
              void 0,
              {
                top: true,
                blur: true
              }
            ]
          ]),
          _createVNode(_component_Calendar, {
            modelValue: _ctx.filters.endMonth.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters.endMonth.value = $event)),
            class: "p-mt-3",
            view: "month",
            dateFormat: "MM yy",
            showIcon: true,
            minDate: new Date(),
            yearRange: "2020:2024",
            placeholder: "Seleccionar",
            showButtonBar: true
          }, null, 8, ["modelValue", "minDate"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-text button-underlined"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.DaysAndHours,
        header: _ctx.allColumns.get(_ctx.ColumnFields.DaysAndHours)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.DaysAndHours),
        bodyClass: "bg-gray",
        showFilterMatchModes: false,
        filterField: "days"
      }, {
        body: _withCtx(({ data: { calendar } }) => [
          (calendar.hours && calendar.daysOfTheWeekNames)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendar.daysOfTheWeekNames, (day, i) => {
                    return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.isLastItem(i, (calendar.daysOfTheWeekNames))
                ? day
                : `${day} y `), 1))
                  }), 128))
                ]),
                _createElementVNode("span", null, _toDisplayString(calendar.hours?.get(_ctx.CourseHours.Start)) + " a " + _toDisplayString(calendar.hours?.get(_ctx.CourseHours.End)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        filter: _withCtx(() => [
          _hoisted_12,
          _createVNode(_component_DaysOfWeekSelector, {
            class: "p-mt-3",
            modelValue: _ctx.filters.days.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters.days.value = $event))
          }, null, 8, ["modelValue"])
        ]),
        filterclear: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cleanFilters([_ctx.CourseFiltersProps.days]))),
            class: "p-button-text button-underlined"
          })
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.StudentCapacity,
        header: _ctx.allColumns.get(_ctx.ColumnFields.StudentCapacity)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.StudentCapacity),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data: { studentCapacity } }) => [
          _createTextVNode(_toDisplayString(studentCapacity.currentStudents ? studentCapacity.currentStudents : studentCapacity.min) + "/ " + _toDisplayString(studentCapacity.max), 1)
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.StaffAssignment,
        header: _ctx.allColumns.get(_ctx.ColumnFields.StaffAssignment)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.StaffAssignment),
        bodyClass: "bg-gray",
        filterField: "teacherAssigned",
        showFilterMatchModes: false
      }, {
        body: _withCtx(({data, data: { _id } }) => [
          (_ctx.isLoadingStaffMemberSummaries)
            ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.staffMemberSummaryByCourse.get(_id)?.teachers?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffMemberSummaryByCourse.get(_id)?.teachers, (teacher) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: teacher._id,
                          class: "p-d-flex p-ai-baseline p-col-12 p-p-0"
                        }, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_CoderBadge, {
                              text: teacher.fullName,
                              backgroundColor: _ctx.CSSColors.GreenBrain,
                              fontSize: "12px",
                              rounded: ""
                            }, null, 8, ["text", "backgroundColor"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_CoderBadge, {
                          text: "Sin asignar",
                          class: "p-text-center",
                          backgroundColor: _ctx.CSSColors.RedBrain,
                          fontSize: "12px",
                          rounded: ""
                        }, null, 8, ["backgroundColor"])
                      ])
                    ])),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_CoderBadge, {
                        text: `${_ctx.staffMemberSummaryByCourse.get(_id)?.tutors}/${data.minTutorsRequired}`,
                        class: "p-text-center",
                        backgroundColor: _ctx.staffMemberSummaryByCourse.get(_id)?.tutors < data.minTutorsRequired ? _ctx.CSSColors.RedBrain : _ctx.CSSColors.GreenBrain,
                        fontSize: "12px",
                        rounded: ""
                      }, null, 8, ["text", "backgroundColor"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_CoderBadge, {
                        text: _ctx.staffMemberSummaryByCourse.get(_id)?.hasCoordinator ? '1' : '0',
                        class: "p-text-center",
                        backgroundColor: _ctx.staffMemberSummaryByCourse.get(_id)?.hasCoordinator ? _ctx.CSSColors.GreenBrain : _ctx.CSSColors.RedBrain,
                        fontSize: "12px",
                        rounded: ""
                      }, null, 8, ["text", "backgroundColor"])
                    ])
                  ])
                ])
              ]))
        ]),
        filter: _withCtx(() => [
          _hoisted_27,
          _createVNode(_component_TrueOrFalseSelector, {
            modelValue: _ctx.filters.teacherAssigned.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters.teacherAssigned.value = $event)),
            placeholder: "Profesor",
            trueLabel: "Asignado",
            falseLabel: "Sin asignar",
            class: "p-mt-5"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_TrueOrFalseSelector, {
            modelValue: _ctx.filters.tutorsCompleted.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters.tutorsCompleted.value = $event)),
            placeholder: "Tutores",
            trueLabel: "Completos",
            falseLabel: "Incompletos",
            class: "p-mt-5"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_TrueOrFalseSelector, {
            modelValue: _ctx.filters.coordinatorAssigned.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filters.coordinatorAssigned.value = $event)),
            placeholder: "Coordinadores",
            trueLabel: "Asignado",
            falseLabel: "Sin asignar",
            class: "p-mt-5"
          }, null, 8, ["modelValue"])
        ]),
        filterclear: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cleanFilters([_ctx.CourseFiltersProps.teacherAssigned, _ctx.CourseFiltersProps.tutorsCompleted, _ctx.CourseFiltersProps.coordinatorAssigned]))),
            class: "p-button-text button-underlined"
          })
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.Status,
        header: _ctx.allColumns.get(_ctx.ColumnFields.Status)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.Status),
        bodyClass: "bg-gray",
        filterField: "isSoldOut",
        showFilterMatchModes: false
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_28, [
            (data.configTags?.includes(_ctx.ConfigurationTag.SoldOut))
              ? (_openBlock(), _createBlock(_component_CoderBadge, {
                  key: 0,
                  text: "SoldOut",
                  class: "p-text-center",
                  backgroundColor: _ctx.CSSColors.Black,
                  textColor: _ctx.CSSColors.White,
                  fontSize: "12px",
                  rounded: ""
                }, null, 8, ["backgroundColor", "textColor"]))
              : _createCommentVNode("", true),
            (data.status === _ctx.CourseStatus.Cancelled)
              ? (_openBlock(), _createBlock(_component_CoderBadge, {
                  key: 1,
                  text: "Cancelada",
                  class: "p-text-center",
                  backgroundColor: _ctx.CSSColors.RedBrain,
                  textColor: _ctx.CSSColors.White,
                  fontSize: "12px",
                  rounded: ""
                }, null, 8, ["backgroundColor", "textColor"]))
              : _createCommentVNode("", true),
            _createVNode(_component_CoderBadge, {
              text: `Comienza en: ${ data.daysUntilStart } días`,
              class: "p-text-center",
              backgroundColor: _ctx.CSSColors.White,
              fontSize: "12px",
              border: "1px solid",
              rounded: ""
            }, null, 8, ["text", "backgroundColor"])
          ])
        ]),
        filter: _withCtx(() => [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.filters.isSoldOut.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filters.isSoldOut.value = $event)),
                class: "p-mr-2",
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_32
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.filters.isCancelled.value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filters.isCancelled.value = $event)),
                class: "p-mr-2",
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_34
            ])
          ])
        ]),
        filterclear: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cleanFilters([_ctx.CourseFiltersProps.isSoldOut, _ctx.CourseFiltersProps.isCancelled]))),
            class: "p-button-text button-underlined"
          })
        ]),
        _: 1
      }, 8, ["field", "header", "hidden"])
    ]),
    _: 1
  }, 8, ["rows", "value", "loading", "filters", "totalRecords", "first", "onUpdate:filters"]))
}